import service from "@/store/services/bids-service";

export const state = () => ({
  list: {},
  bid: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, bid) => {
    state.bid = bid;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((bid) => {
      commit("SET_RESOURCE", bid);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((bid) => {
      commit("SET_RESOURCE", bid);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((bid) => {
      commit("SET_RESOURCE", bid);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  bid: (state) => state.bid,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((bid) => ({
      id: bid.id,
    }));
  },
};

const bids = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default bids;
